/**
 * @file Header.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Header component.
 */
const vHeader = () => {
	const header = document.querySelector('.v-header');

	if (!header) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const wrap = header.querySelector('.v-header__wrap');
	const link = header.querySelector('.v-header__logo-link');
	const mark = header.querySelector('.v-header__mark');
	const text = header.querySelector('.v-header__logo-text');
	const newAmerican = text.querySelector('.v-header__na');
	const careers = text.querySelector('.v-header__careers');

	const logoTl = gsap.timeline({
		scrollTrigger: {
			trigger: wrap,
			start: 'top top',
			end: `bottom top+=15px`,
			scrub: true,
			onLeaveBack: () => {
				header.style.setProperty('--header-bottom', 0);
				header.style.setProperty('--shadow-progress', 0);
				gsap.set(text, { clearProps: 'y' });
				gsap.set(link, { clearProps: 'height' });
			},
		},
		onUpdate() {
			header.style.setProperty(
				'--header-bottom',
				`${this.progress() * 0.75}rem`
			);
			header.style.setProperty(
				'--shadow-progress',
				`${this.progress() * 0.05}`
			);
		},
	});

	logoTl
		.to(text, {
			y: () =>
				-1 *
					(careers.getBoundingClientRect().top -
						text.getBoundingClientRect().top) +
				(mark.getBoundingClientRect().height -
					careers.getBoundingClientRect().height) /
					2,
		})
		.to(
			newAmerican,
			{
				opacity: 0,
			},
			'<'
		)
		.to(
			link,
			{
				height: mark.getBoundingClientRect().height,
			},
			'<'
		);
};

export default vHeader;
